import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { LocaleProvider } from './components/LocaleProvider';
import { Home } from './pages/Home';
import { CategoryPage } from './pages/CategoryPage';
import { ContactPage } from './pages/ContactPage';
import { StandardPage } from './pages/StandardPage';
import { WholesalePage } from './pages/WholesalePage';
export function App() {
  return <LocaleProvider data-id="element-0" data-mp="2rk46v58p32hj">
      <BrowserRouter data-id="element-1" data-mp="2rlowqhk2dx92">
        <Routes data-id="element-2" data-mp="2rit2b37fdqpd">
          <Route path="/" element={<Home data-id="element-4" data-mp="2mmcbu2cr7094" />} data-id="element-3" data-mp="2mlu9cnzhzpsr" />
          <Route path="/categories" element={<CategoryPage data-id="element-6" data-mp="2mjpwhgjmfggc" />} data-id="element-5" data-mp="2mmvob3jmwwfr" />
          <Route path="/brands" element={<StandardPage data-id="element-8" data-mp="31bs09botatln" />} data-id="element-7" data-mp="31agoopp4khjz" />
          <Route path="/gallery" element={<StandardPage data-id="element-10" data-mp="2wk06yte9u9rt" />} data-id="element-9" data-mp="31c1iue7j1yhb" />
          <Route path="/news" element={<StandardPage data-id="element-12" data-mp="2wifc12o1ootf" />} data-id="element-11" data-mp="2wiyxuugtfxcq" />
          <Route path="/about" element={<StandardPage data-id="element-14" data-mp="28tmex2vosax8" />} data-id="element-13" data-mp="28ufpkexrnkkn" />
          <Route path="/wholesale" element={<WholesalePage data-id="element-16" data-mp="28s2ztflro5x1" />} data-id="element-15" data-mp="28suu8n3mnxlq" />
          <Route path="/contact" element={<ContactPage data-id="element-18" data-mp="23ujha3i1d6za" />} data-id="element-17" data-mp="23vupcfiil0w7" />
        </Routes>
      </BrowserRouter>
    </LocaleProvider>;
}